import type { StatusPedido } from '@entregas/core';
import type { FiltroClientes } from '../clientes';

// Chaves de cache num lugar só: invalidar "tudo de clientes" é invalidar ['clientes'].
export const chaves = {
  empresa: ['empresa'] as const,
  clientes: {
    todos: ['clientes'] as const,
    lista: (filtro: FiltroClientes) => ['clientes', 'lista', filtro] as const,
    porTelefone: (telefone: string) => ['clientes', 'telefone', telefone] as const,
    busca: (termo: string) => ['clientes', 'busca', termo] as const,
    ficha: (id: string) => ['clientes', 'ficha', id] as const,
    historico: (id: string) => ['clientes', 'historico', id] as const,
    lembrar: ['clientes', 'lembrar'] as const,
  },
  pedidos: {
    todos: ['pedidos'] as const,
    periodo: (inicio: string, fim: string, status?: StatusPedido[]) =>
      ['pedidos', 'periodo', inicio, fim, status ?? 'todos'] as const,
    um: (id: string) => ['pedidos', 'um', id] as const,
    resposta: (id: string) => ['pedidos', 'resposta', id] as const,
    analise: (inicio: string, fim: string) => ['pedidos', 'analise', inicio, fim] as const,
    acerto: (inicio: string, fim: string) => ['pedidos', 'acerto', inicio, fim] as const,
    /** Todas as listas do balcão (para mexer no cache de todas de uma vez). */
    filas: ['pedidos', 'fila'] as const,
    fila: (empresaId: string) => ['pedidos', 'fila', empresaId] as const,
  },
  produtos: {
    todos: ['produtos'] as const,
    lista: (todos: boolean) => ['produtos', todos ? 'todos' : 'ativos'] as const,
  },
  busca: (texto: string) => ['busca', texto] as const,
  entregadores: {
    todos: ['entregadores'] as const,
    posicoes: ['entregadores', 'posicoes'] as const,
    veiculos: ['entregadores', 'veiculos'] as const,
    diasTodos: ['entregadores', 'dias'] as const,
    dias: (id: string, desde: string, ate: string) =>
      ['entregadores', 'dias', id, desde, ate] as const,
  },
  acertos: {
    todos: ['acertos'] as const,
    dia: (dia: string) => ['acertos', 'dia', dia] as const,
  },
  appEntregador: {
    todos: ['app-entregador'] as const,
    entregas: ['app-entregador', 'entregas'] as const,
    perfil: ['app-entregador', 'perfil'] as const,
    lojas: ['app-entregador', 'lojas'] as const,
    regras: ['app-entregador', 'regras'] as const,
    ganhosTodos: ['app-entregador', 'ganhos'] as const,
    ganhos: (desde: string, ate: string) => ['app-entregador', 'ganhos', desde, ate] as const,
  },
  recursosDoApp: ['recursos-do-app'] as const,
  lugares: ['lugares'] as const,
  ruas: (termo: string) => ['lugares', 'ruas', termo] as const,
  rastreio: (token: string) => ['rastreio', token] as const,
  logoDoRastreio: (token: string) => ['logo-do-rastreio', token] as const,
};
